<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
  <ul class="confirm-details" *ngIf="data.details?.length">
    <li *ngFor="let detail of data.details">{{ detail }}</li>
  </ul>
  <p class="confirm-warning" *ngIf="data.warning">{{ data.warning }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Abbrechen</button>
  <button mat-raised-button color="warn" (click)="onConfirm()">{{ data.confirmText || 'Bestätigen' }}</button>
</mat-dialog-actions>
